export const LEARNING_HUB_AVAILABILITY_KEY = 'learningHubAvailable';
export const LEARNING_HUB_AVAILABILITY_EVENT = 'learningHubAvailabilityChanged';
export const LEARNING_HUB_UNAVAILABLE_MESSAGE =
  'Learning Hub is not available for your project';
export const LEARNING_HUB_ACCESS_KEY = 'learningHubAccess';

export const isLearningHubUnavailableResponse = (response) =>
  response?.status === false
  && response?.message === LEARNING_HUB_UNAVAILABLE_MESSAGE;

export const isLearningHubAccessClosed = (access) =>
  ['scheduled', 'expired'].includes(access?.access_state);

export const setLearningHubAccess = (access) => {
  const nextAccess = access && typeof access === 'object' ? access : null;
  if (nextAccess) {
    localStorage.setItem(LEARNING_HUB_ACCESS_KEY, JSON.stringify(nextAccess));
  } else {
    localStorage.removeItem(LEARNING_HUB_ACCESS_KEY);
  }
};

export const isLearningHubAvailable = () =>
  localStorage.getItem(LEARNING_HUB_AVAILABILITY_KEY) === 'true';

export const setLearningHubAvailability = (available) => {
  localStorage.setItem(LEARNING_HUB_AVAILABILITY_KEY, available ? 'true' : 'false');
  window.dispatchEvent(
    new CustomEvent(LEARNING_HUB_AVAILABILITY_EVENT, { detail: { available } })
  );
};

export const resolveLearningHubAvailability = (response) => {
  const tabs = response?.tabs;
  const hasTabCatalogue = !!(tabs && (tabs.freemium != null || tabs.learning_hub != null));
  const open = !!(response?.status && (
    Array.isArray(response.data)
    || Array.isArray(response.courses)
    || hasTabCatalogue
  ));
  const available = open || isLearningHubAccessClosed(response?.access);
  setLearningHubAvailability(available);
  setLearningHubAccess(available ? response?.access || null : null);
  return available;
};

export const fetchLearningHubAvailability = async (skillsAndTransformation) => {
  const response = await skillsAndTransformation.getLearningHub();
  return resolveLearningHubAvailability(response);
};
